// The tags that tell Google what a page is. Each page has its own title and
// one canonical URL, so Google does not see two URLs as the same page.

import { companyName } from './data/relations.js';
import { currentAddress, currentOf } from './data/entity.js';

export const SITE_URL = 'https://cvr.kinedb.com';
export const BASENAME = '/ui';

/** The canonical URL of an app path such as "/Company/40970533". */
export function canonicalUrl(path) {
  return `${SITE_URL}${BASENAME}${path}`;
}

/** The meta tags of a page: a title, a description and a canonical. */
export function pageMeta({ title, description, path }) {
  const tags = [{ title }];
  if (description) tags.push({ name: 'description', content: description });
  if (path) tags.push({ tagName: 'link', rel: 'canonical', href: canonicalUrl(path) });
  return tags;
}

/** The meta tags of a page that does not exist: Google must not index it. */
export function notFoundMeta() {
  return [{ title: 'Not found – CVR register' }, { name: 'robots', content: 'noindex' }];
}

/** One line about a company for the search result: name, CVR, form, status, address, start. */
export function companyDescription(company) {
  const parts = [`${companyName(company)}, CVR ${company.cvr ?? company.enhedsNummer}`];
  if (company.virksomhedsformlang) parts.push(company.virksomhedsformlang);
  if (company.cvrstatus) parts.push(`status ${company.cvrstatus.toLowerCase()}`);
  const address = currentAddress(company.beliggenhedsadresse);
  if (address) parts.push(address);
  if (company.stiftelsesDato) parts.push(`stiftet ${String(company.stiftelsesDato).slice(0, 10)}`);
  const branche = currentOf(company.hovedbranche)?.branchetekst;
  if (branche) parts.push(branche);
  return `${parts.join('. ')}.`;
}
